export const LOCAL_STORAGE_KEYS = Object.freeze({
  TENANT_DOMAIN: 'tenant_domain',
  ACCESS_TOKEN: 'access',
  ACCESS_TOKEN_DEPRECATED: 'access_token',
  ACCESS_EXPIRES_AT: 'access_expires_at',
  REFRESH_TOKEN: 'refresh',
  REFRESH_TOKEN_DEPRECATED: 'refresh_token',
  REFRESH_EXPIRES_AT: 'refresh_expires_at',
  LOCALE: 'locale',
});
